const generateHexString = (): string => {
    return Array.from(window.crypto.getRandomValues(new Uint8Array(16))).join(
        ''
    );
};

export { generateHexString };
